import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import SupportCoordinationPage from "@/pages/SupportCoordinationPage";
import MentalHealthPage from "@/pages/MentalHealthPage";
import DisabilitySupportPage from "@/pages/DisabilitySupportPage";
import SlesPage from "@/pages/SlesPage";
import BlogsPage from "@/pages/BlogsPage";
import BlogPostPage from "@/pages/BlogPostPage";
import MakeReferralPage from "@/pages/MakeReferralPage";
import ContactUsPage from "@/pages/ContactUsPage";
import CounsellingNdisPage from "@/pages/CounsellingNdisPage";
import EmploymentNdisPage from "@/pages/EmploymentNdisPage";
import RecreationNdisPage from "@/pages/RecreationNdisPage";
import TherapiesNdisPage from "@/pages/TherapiesNdisPage";
import CookieConsent from "@/components/CookieConsent";
import NDISPathwayNavigator from "@/components/NDISPathwayNavigator";
import GetOnNdisPage from "@/pages/GetOnNdisPage";
import WhatIsNdisSupportProviderPage from "@/pages/WhatIsNdisSupportProviderPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services/support-coordination" element={<SupportCoordinationPage />} />
            <Route path="/services/mental-health" element={<MentalHealthPage />} />
            <Route path="/services/disability-support" element={<DisabilitySupportPage />} />
            <Route path="/services/sles" element={<SlesPage />} />
            <Route path="/services/counselling" element={<CounsellingNdisPage />} />
            <Route path="/services/employment" element={<EmploymentNdisPage />} />
            <Route path="/services/recreation" element={<RecreationNdisPage />} />
            <Route path="/services/therapies" element={<TherapiesNdisPage />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/blogs/:slug" element={<BlogPostPage />} />
            <Route path="/make-a-referral" element={<MakeReferralPage />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/get-on-ndis-free" element={<GetOnNdisPage />} />
            <Route path="/what-is-ndis-support-provider" element={<WhatIsNdisSupportProviderPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieConsent />
        <NDISPathwayNavigator />
    </div>
  );
}

export default App;
